import { publicAxios } from '@/services/api'

export const _login = (data) => {
    return publicAxios.post('/auth/login', data)
        .then(response => response.data)
}

export const _logout = () => {
    return publicAxios.delete('/auth/logout')
        .then(response => response.data)
}
